/* ── KickAss Shared Modal Controller ───────────────────────────────────────── */

window.KaModals = (function() {
  'use strict';

  var activeModal = null;
  var confettiLoaded = false;
  var confettiLoading = false;

  function loadConfetti(callback) {
    if (window.confetti) {
      if (callback) callback();
      return;
    }
    if (confettiLoading) return; // already fetching
    confettiLoading = true;
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.6.0/dist/confetti.browser.min.js';
    script.onload = function() {
      confettiLoaded = true;
      if (callback) callback();
    };
    document.head.appendChild(script);
  }

  function triggerConfetti() {
    if (window.confetti) {
      window.confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2147483647
      });
    } else {
      loadConfetti(function() {
        window.confetti({
          particleCount: 150,
          spread: 70,
          origin: { y: 0.6 },
          zIndex: 2147483647
        });
      });
    }
  }

  function openModal(modalEl, options) {
    if (!modalEl) return;
    options = options || {};

    // Move to body to ensure root stacking context (z-index fixes)
    if (modalEl.parentElement !== document.body) {
      document.body.appendChild(modalEl);
    }

    modalEl.style.display = 'flex';
    modalEl.removeAttribute('aria-hidden');
    
    // Force reflow
    void modalEl.offsetWidth;
    
    requestAnimationFrame(function() {
      modalEl.classList.add('open');
      if (typeof options.onOpen === 'function') {
        options.onOpen();
      }
    });

    document.body.style.overflow = 'hidden';
    activeModal = modalEl;

    if (options.confetti) {
      triggerConfetti();
    }
  }

  function closeModal(modalEl, options) {
    if (!modalEl) return;
    options = options || {};

    modalEl.classList.remove('open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    
    if (activeModal === modalEl) {
      activeModal = null;
    }

    setTimeout(function() {
      if (!modalEl.classList.contains('open')) {
        modalEl.style.display = 'none';
      }
    }, 300);

    // Handle localStorage suppression if requested
    if (options.remember && options.storageKey && options.hideDays) {
      var expiry = Date.now() + (Number(options.hideDays) * 24 * 60 * 60 * 1000);
      try {
        localStorage.setItem(options.storageKey, JSON.stringify({ expiry: expiry }));
      } catch (e) {
        console.warn('LocalStorage failed', e);
      }
    }
  }

  function hasSeenModal(storageKey) {
    if (!storageKey) return false;
    try {
      var seenData = JSON.parse(localStorage.getItem(storageKey));
      return seenData && Date.now() < seenData.expiry;
    } catch (e) {
      return false;
    }
  }

  // Global event listeners for close actions
  document.addEventListener('click', function(e) {
    if (!activeModal) return;

    // Click on close button
    if (e.target.closest('.js-close-modal, .ka-close-modal, .js-close-ka-comp, .js-close-gwp-modal')) {
      e.preventDefault();
      // Check if this modal needs to be remembered (e.g. GWP or Club)
      var remember = e.target.closest('.ka-gwp-modal, .ka-club-modal') !== null;
      var storageKey = activeModal.dataset.storageKey;
      var hideDays = activeModal.dataset.hideDays || 3;
      
      closeModal(activeModal, {
        remember: remember,
        storageKey: storageKey,
        hideDays: hideDays
      });
      return;
    }

    // Click on backdrop
    if (e.target === activeModal) {
      var remember = activeModal.classList.contains('ka-gwp-modal') || activeModal.classList.contains('ka-club-modal');
      var storageKey = activeModal.dataset.storageKey;
      var hideDays = activeModal.dataset.hideDays || 3;
      
      closeModal(activeModal, {
        remember: remember,
        storageKey: storageKey,
        hideDays: hideDays
      });
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeModal) {
      var remember = activeModal.classList.contains('ka-gwp-modal') || activeModal.classList.contains('ka-club-modal');
      var storageKey = activeModal.dataset.storageKey;
      var hideDays = activeModal.dataset.hideDays || 3;
      
      closeModal(activeModal, {
        remember: remember,
        storageKey: storageKey,
        hideDays: hideDays
      });
    }
  });

  // Expose API
  return {
    open: openModal,
    close: closeModal,
    hasSeen: hasSeenModal,
    triggerConfetti: triggerConfetti
  };

})();
